"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryFilter = void 0;
/**
 * It allows you to filter products into a specific category
 */
var CategoryFilter = /** @class */ (function () {
    /** @param filterValue Product category id to filter */
    function CategoryFilter(filterValue) {
        this.enableMultiple = true;
        this.urlParam = 'filter';
        this.value = filterValue;
    }
    return CategoryFilter;
}());
exports.CategoryFilter = CategoryFilter;
//# sourceMappingURL=CategoryFilter.js.map